"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  fragment SearchProductRow on PlpRow {\n    content {\n      __typename\n      ...ProductWithShades\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  fragment SearchResultsProducts on ProductSearchPageProducts {\n    searchedTerm\n    totalProductsCount\n    orderByOptions {\n      ...OrderByOptions\n    }\n    facets {\n      ...ProductListingFacets\n    }\n    rows {\n      __typename\n      ...SearchProductRow\n    }\n    relatedCategoryLinks @include(if: $withRelatedLinks) {\n      ...SearchLink\n    }\n    relatedBrandLinks @include(if: $withRelatedLinks) {\n      ...SearchLink\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchResultsProducts = void 0;
var _fetching = require("@ori/fetching");
var _productBox = require("@ori/product-box");
var _links = require("./links");
var _orderByOptions = require("./orderByOptions");
var _productListingFacets = require("./productListingFacets");
const searchResultsProductsRow = (0, _fetching.gql)(_templateObject(), _productBox.PRODUCT_WITH_SHADES_FRAGMENT);
const searchResultsProducts = exports.searchResultsProducts = (0, _fetching.gql)(_templateObject1(), searchResultsProductsRow, _orderByOptions.orderByOptions, _productListingFacets.productListingFacets, _links.links);
